// extracted by mini-css-extract-plugin
module.exports = {"footer":"HS002_footer_2A8o_"};